<template>
  <main :class="$style['error']">
    <NuxtLink to="/" :class="$style['error__logo']" aria-label="Hengelose Revue, naar de homepage"><Logo /></NuxtLink>
    <h1 :class="$style['error__title']">{{ error?.statusCode === 404 ? 'Mis!' : 'Oeps' }}</h1>
    <p :class="$style['error__text']">
      {{ error?.statusCode === 404
        ? 'Deze pagina bestaat niet (meer). Misschien vind je het via de homepage.'
        : 'Er ging iets mis bij het laden van deze pagina. Probeer het nog een keer via de homepage.' }}
    </p>
    <Button variant="primary" size="lg" @click="clearError({ redirect: '/' })">Naar de homepage</Button>
    <div v-if="error?.stack" :class="$style['error__stack']" v-html="error.stack" />
  </main>
</template>
<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError
})

useStageTheme()
console.error(props.error)
</script>
<style module>
.error {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--spacing-xl);
  min-height: 100svh;
  padding: var(--stage-section) var(--stage-gutter);
  background: var(--stage-black);
  color: var(--stage-white);
}

.error__logo {
  display: block;
  width: 10rem;
}

.error__title {
  margin: 0;
  font-size: clamp(6rem, 2rem + 18vw, 20rem);
  line-height: 0.8;
}

.error__text {
  max-width: var(--stage-measure);
  margin: 0;
  font-size: var(--stage-text);
  color: var(--stage-soft);
}

.error__stack {
  max-width: 100%;
  overflow-x: auto;
  font-size: var(--font-size-small);
  color: var(--stage-soft);
}
</style>
